<template>
  <span class="alert-severity-pill" :class="`alert-severity-pill--${severity}`">
    <svg v-if="severity === 'info'" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="9" cy="9" r="6.5"/><path d="M9 8v4M9 6v.01"/></svg>
    <svg v-else viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 2.5 16 15H2z"/><path d="M9 7.5v3.5M9 13v.01"/></svg>
    {{ meta.label }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { severityMeta } from '@root/services/alertFormat';

// `alert-severity-pills.html`'s severity taxonomy — info/warning/serious/
// critical. Severity is never colour-alone: every pill ships a glyph
// alongside the label (info circle, or a warning triangle at two colour
// weights for warning/serious/critical) — see that mockup's anatomy note.
const props = defineProps({
  severity: {
    type: String,
    required: true,
  },
});

const meta = computed(() => severityMeta(props.severity));
</script>

<style lang="scss">
.alert-severity-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 4px 10px;
  border-radius: 14px;
  white-space: nowrap;

  svg {
    width: 11px;
    height: 11px;
    flex-shrink: 0;
  }

  &--info {
    background: #ddeaf4;
    color: #215d84;
  }

  &--warning {
    background: #fbeeda;
    color: #8a5a0d;
  }

  &--serious {
    background: #fbe1e1;
    color: #a53232;
    border: 1px solid #eeb8b8;
  }

  &--critical {
    background: var(--theme-status-danger, #d14343);
    color: #fff;
  }
}
</style>
